// extracted by mini-css-extract-plugin
export default {"two-fa-contact-footer":"EMtsXBTF3sGItmbpwdD9lQ=="};